import Vue from 'vue'
import VueRouter from 'vue-router'
import { ContentfulEntry } from '@neurotrack/web-shared-components'
import { startCase } from 'lodash-es'
import store from '@/store'
import { Analytics } from '@/util/env'
import i18n from '../i18n'

Vue.use(VueRouter)
const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import(/* webpackChunkName: "common" */ '@/views/Home.vue')
  },
  {
    path: '/record',
    name: 'Recording',
    component: () => import(/* webpackChunkName: "common" */ '@/views/VideoRecordingPoC.vue')
  },
  {
    path: '/preamble',
    name: 'WhatToExpect',
    component: () => import(/* webpackChunkName: "common" */ '@/views/WhatToExpect.vue'),
    beforeEnter: (to, from, next) => {
      const hasCameraAccess = store.state?.video?.accessToCamera
      if (hasCameraAccess) {
        next({ name: 'Home' })
      } else {
        next()
      }
    }
  },
  {
    path: '/video-info',
    name: 'Video Info',
    component: () => import(/* webpackChunkName: "common" */ '@/views/VideoInfoPage.vue')
  },
  {
    path: '/video-check',
    name: 'Video',
    component: () => import(/* webpackChunkName: "common" */ '@/views/VideoCheck.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "profile" */ '@/views/Login.vue'),
    props: true
  },
  {
    path: '/profile',
    name: 'Profile',
    component: () => import(/* webpackChunkName: "profile" */ '@/views/Profile.vue'),
    meta: { auth: true },
    props: ({ query }) => ({ required: (query.rqd === 'true'), redirect: query.redirect })
  },
  {
    path: '/faqs',
    name: 'FAQCategories',
    component: () => import(/* webpackChunkName: "content" */ '@/views/FAQCategories.vue')
  },
  {
    path: '/faqs/:category',
    name: 'FAQs',
    component: () => import(/* webpackChunkName: "content" */ '@/views/FAQs.vue'),
    props: true
  },
  {
    path: '/exam/:exam/:phase/:trial',
    redirect: to => ({ // TODO(?): pass params as props?
      path: `/exam/${to.params.exam}`
    })
  },
  {
    path: '/pre-exam/:exam',
    name: 'PreExam',
    component: () => import(/* webpackChunkName: "common" */ '@/views/EoPCheck/EoPCheck.vue'),
    props: ({ params }) => ({ examRoute: params.exam }),
    beforeEnter: (to, from, next) => {
      const hasCameraAccess = store.state?.video?.accessToCamera
      if (!hasCameraAccess) { // TODO: Image pairs needs to prevent nav if no camera
        next({ path: `/exam/${to.params.exam}` })
      } else {
        next()
      }
    }
  },
  {
    path: '/exam/:exam',
    name: 'ESSContainer',
    component: () => import(/* webpackChunkName: "exams" */ '@/components/ESSContainer.vue'),
    props: ({ params }) => ({ examRoute: params.exam })
  },
  {
    path: '/category/:category',
    name: 'category',
    component: () => import(/* webpackChunkName: "exams" */ '@/views/LearnContent.vue'),
    props: true
  },
  {
    path: '/category/:category/:slug',
    name: 'categorySlug',
    component: () => import(/* webpackChunkName: "exams" */ '@/views/LearnContentSlug.vue'),
    props: true
  },
  {
    path: '/privacy',
    name: 'examsPrivacy',
    component: ContentfulEntry,
    props: () => ({
      pageTitle: startCase(i18n.t('register_body_pp_link')),
      entryName: 'privacy'
    })
  },
  {
    path: '/terms',
    name: 'examsTerms',
    component: ContentfulEntry,
    props: () => ({
      pageTitle: startCase(i18n.t('register_body_tos_link')),
      entryName: 'terms'
    })
  }
]

const router = new VueRouter({
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    return { x: 0, y: 0 }
  }
})

let unsubscribe

router.beforeEach((to, from, next) => {
  const redirectTo = to.path
  Analytics.track('Route', { path: redirectTo })

  if (!unsubscribe) {
    unsubscribe = store.subscribe(({ type, payload }) => {
      if (type === 'setRouteError' && payload === 401) {
        store.dispatch('setHttpError', false)
        if (!redirectTo.includes('/login')) {
          router.push({
            path: 'login'
          })
        }
      }
    })
  }

  if (
    !redirectTo.includes('/login')
    && (store.state.routeError === 401 || !store.getters['user/isLoggedIn'])
  ) {
    next('/login')
  } else {
    next()
  }
})

export default router
